import ShareholderTile from "../share-holder-tile";

/**
 * Capital-investment figures from `CapitalInvestment` on the application. Each
 * one is optional: an applicant who took no loan has no loan amount, and a blank
 * row is more honest than a cell reading "N/A".
 */
interface IInvestmentDetailsCardProps {
    investMentAmount?: string | number;
    personalContribution?: string | number;
    loanAmount?: string | number;
    institutionProvidingLoanName?: string;
    bankName?: string;
    bankAddress?: string;
    titleHeader: string,
    shareholders: Array<any>
}

function DetailCell({ label, value, className }: { label: string; value?: string | number; className?: string }) {
    if (value === undefined || value === null || value === "") return null;
    return (
        <div className={className}>
            <span className="text-md text-gray-500">{label}</span>
            <p className="text-sm font-semibold capitalize">{value}</p>
        </div>
    );
}

export default function InvestmentDetailsCard({
    investMentAmount,
    personalContribution,
    loanAmount,
    institutionProvidingLoanName,
    bankName,
    bankAddress,
    titleHeader,
    shareholders
}: IInvestmentDetailsCardProps) {
    const hasDetails = [
        investMentAmount,
        personalContribution,
        loanAmount,
        institutionProvidingLoanName,
        bankName,
        bankAddress,
    ].some((value) => value !== undefined && value !== null && value !== "");

    return (
        <div>
            <h1 className=" text-lg font-semibold text-[#3C1E03]">{titleHeader}</h1>
            <div className="bg-white shadow-md p-6 rounded-xl mt-2">
                {hasDetails ? (
                    <div className="grid grid-cols-2 gap-4">
                        <DetailCell label="Estimated Investment Amount" value={investMentAmount} className="col-span-2" />
                        <DetailCell label="Personal Contribution" value={personalContribution} />
                        <DetailCell label="Loan Amount" value={loanAmount} />
                        <DetailCell label="Institution Providing the Loan" value={institutionProvidingLoanName} />
                        <DetailCell label="Bank Name" value={bankName} />
                        <DetailCell label="Bank Address" value={bankAddress} />
                    </div>
                ) : (
                    <p className="text-sm text-gray-500">
                        No capital investment details recorded for this application.
                    </p>
                )}
                {shareholders && shareholders.length > 0 && (
                    <div className="flex flex-col gap-2 mt-2">
                        <ShareholderTile
                            shareholders={shareholders}
                        />
                    </div>
                )}

            </div>
        </div>

    );
}
